import { Subject } from 'rxjs';

import EmailChangeDialog from '../components/emailChange/EmailChangeDialog';
import cancelSubscriptionDialog from '../components/patientAccount/CancelSubscriptionDialog';
import EditDetails from '../components/patientAccount/EditDetails';
import ValidationException from '../exceptions/ValidationException';
import ChangePassword from '../models/PasswordReset';
import User from '../models/User';

const detailsFields = [
  { label: 'Name', name: 'name', placeholder: 'Name', required: true, type: 'text' },
  { label: 'Preferred Name', name: 'preferredName', placeholder: 'Preferred Name', required: true, type: 'text' },
  {
    label: 'Date of Birth',
    labelPosition: 'top',
    name: 'dateOfBirth',
    placeholder: 'MM/DD/YYYY',
    type: 'date',
  },
  {
    items: [
      { label: 'Female', value: 'female' },
      { label: 'Male', value: 'male' },
      { label: 'Other', value: 'other' },
    ],
    label: 'Gender',
    labelPosition: 'top',
    name: 'gender',
    placeholder: 'Select',
    type: 'select',
  },
  { label: 'Phone number', name: 'phoneNumber', placeholder: '+27828501512', required: true, type: 'phone' },
  { disabled: true, label: 'Email address', name: 'email', placeholder: 'email@address.com', required: true, type: 'text' },
];

const passwordFields = [
  { hidePasswordIcon: true, label: 'Old Password', labelPosition: 'top', name: 'currentPassword', placeholder: '***********', type: 'password' },
  { hidePasswordIcon: true, label: 'New Password', labelPosition: 'top', name: 'newPassword', placeholder: '***********', type: 'password' },
  { hidePasswordIcon: true, label: 'Repeat Password', labelPosition: 'top', name: 'repeatPassword', placeholder: '***********', type: 'password' },
];
export default class PatientAccountBloc {
  constructor({ drawerRepository, userRepository, authRepository, dialogRepository, paymentRepository }) {
    this.drawerRepository = drawerRepository;
    this.userRepository = userRepository;
    this.authRepository = authRepository;
    this.dialogRepository = dialogRepository;
    this.paymentRepository = paymentRepository;
  }

  openChangeEmailDialog() {
    this.dialogRepository.loadDialog(EmailChangeDialog, {
      onCancel: () => this.dialogRepository.toggleDialog(false),
    });
  }

  openUpdateDialog() {
    const errorsStream$ = new Subject();
    const props = {
      buttonText: 'Update My Details',
      data: this.userRepository.userDetails$.getValue(),
      errorsStream: errorsStream$,
      fields: detailsFields,
      onClose: () => this.closeDrawer(),
      onEdit: (data) => this.editDetails(data, errorsStream$),
      title: 'Update Details',
      validation: User.validateCreate,
    };
    this.drawerRepository.loadDrawer(EditDetails, props);
  }

  openChangePasswordDialog() {
    const errorsStream$ = new Subject();
    const props = {
      buttonText: 'Change Password',
      data: this.userRepository.userDetails$.getValue(),
      errorsStream: errorsStream$,
      fields: passwordFields,
      onClose: () => this.closeDrawer(),
      onEdit: (data) => this.changePassword(data, errorsStream$),
      title: 'Change Password',
      validation: ChangePassword.validateCreate,
    };
    this.drawerRepository.loadDrawer(EditDetails, props);
  }

  closeDrawer() {
    this.drawerRepository.toggleDrawer(false);
  }

  async editDetails(userDetails, errorsStream = null) {
    try {
      const updatedDetails = await this.userRepository.updateDetails(userDetails);
      this.userRepository.userDetails$.next({
        ...this.userRepository.userDetails$.getValue(),
        ...updatedDetails,
      });
      this.drawerRepository.toggleDrawer(false);
    } catch (error) {
      if (errorsStream && error instanceof ValidationException) {
        errorsStream.next(error.errors);
      }
    }
  }

  openCancelPlanDialog() {
    const props = {
      onAgree: () => this.cancelPlan(),
      onCancel: () => this.dialogRepository.toggleDialog(false),
    };

    this.dialogRepository.loadDialog(cancelSubscriptionDialog, props);
  }

  async cancelPlan() {
    await this.paymentRepository.cancelPlan();
    await this.userRepository.getCurrentUser();
    this.dialogRepository.toggleDialog(false);
  }

  async changePassword({ currentPassword, newPassword }, errorsStream = null) {
    try {
      await this.userRepository.changePassword(currentPassword, newPassword);
      this.drawerRepository.toggleDrawer(false);
    } catch (error) {
      if (errorsStream && error instanceof ValidationException) {
        errorsStream.next(error.errors);
      }
    }
  }

  get details$() {
    return this.userRepository.userDetails$;
  }

  async getCurrentUser() {
    return this.userRepository.getCurrentUser();
  }
}
